module.exports = __webpack_public_path__ + "img/zoom-out.14056014.svg";